import { JsonUtils } from '../../utils/json.util'
import { StatusPatient } from './followUp'

export class Conducts {

    // Conduct
    private _surgeries: string[] | undefined
    private _chemotherapy: string | undefined
    private _radiotherapy: string | undefined
    private _stage: string | undefined
    private _date_of_death: string | null | undefined


    constructor() {
        this._stage = StatusPatient.TRACKING.toLowerCase()
        this._surgeries = []
    }

    // Conduct
    get surgeries(): string[] | undefined {
        return this._surgeries
    }

    set surgeries(value: string[] | undefined) {
        this._surgeries = value
    }
    get chemotherapy(): string | undefined {
        return this._chemotherapy
    }

    set chemotherapy(value: string | undefined) {
        this._chemotherapy = value
    }

    get radiotherapy(): string | undefined {
        return this._radiotherapy
    }

    set radiotherapy(value: string | undefined) {
        this._radiotherapy = value
    }
    get stage(): string | undefined {
        return this._stage
    }

    set stage(value: string | undefined) {
        this._stage = value
    }
    get date_of_death(): string | null | undefined {
        return this._date_of_death
    }

    set date_of_death(value: string | null | undefined) {
        this._date_of_death = value
    }

    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): Conducts {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        // Conduct
        if (json.surgeries !== undefined) {
            this.surgeries = json.surgeries
        }
        if (json.chemotherapy !== undefined) {
            this.chemotherapy = json.chemotherapy
        }
        if (json.radiotherapy !== undefined) {
            this.radiotherapy = `${json.radiotherapy}`
        }
        if (json.stage !== undefined) {
            this.stage = json.stage
        }
        if (json.date_of_death !== undefined) {
            this.date_of_death = json.date_of_death
        }

        return this
    }

    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {
        return {
            // Conduct
            surgeries: this.surgeries || undefined,
            chemotherapy: this.chemotherapy || undefined,
            radiotherapy: this.radiotherapy ? this.radiotherapy === "true" : undefined,
            stage: this.stage || undefined,
            date_of_death: this.date_of_death || undefined
        }
    }
}